<template>
  <div id="spin-event-creation-method">
    <illustration-card
      v-for="(card, key, index) in cards"
      :key="index"
      :illustration="card.illustration"
      :heading="key"
      :subheading="card.subheading"
      :body="card.body"
      @click="chooseMethod(key)"
    />
  </div>
</template>
<script>
import IllustrationCard from "../../../Components/UI/IllustrationCard.vue";
export default {
  data() {
    return {
      method: undefined,
      step: 0,
      cards: {
        Guided: {
          illustration: "walking-man",
          subheading: null,
          body: [
            "Allows you to add all information for the event.",
            "Gives you the maximum amount of control.",
          ],
        },
        Express: {
          illustration: "running-man",
          subheading: "Coming Soon",
          body: [
            "Allows you to put a minimum amount of information, and allows your client to submit the event details.",
            "The fastest way to create an event.",
          ],
        },
      },
    };
  },
  computed: {},
  methods: {
    chooseMethod(method) {
      this.$emit("method-chosen", method);
    },
  },
  created() {},
  components: {
    IllustrationCard,
  },
  props: [],
  emits: ["method-chosen"],
};
</script>
<style scoped>
@media screen {
  #spin-event-creation-method {
    width: 100%;
    /* height: 100%; */
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
  }
  @media (min-width: 800px) {
    #spin-event-creation-method {
      width: 100%;
      /* height: 100%; */
      display: flex;
      flex-direction: row;
      justify-content: space-evenly;
      align-items: center;
    }
  }
}
</style>
